import type { ReactNode } from 'react';
import React from 'react';

import { withModal } from '../../components/common/modal/withModal';
import { ModalStateContext } from './modal-state.context';

interface Props {
  children: ReactNode;
  setModal: (modal: React.ReactNode, requireAuth?: boolean) => void;
  hideModal: () => void;
}

const ModalStateContextProviderContainer: React.FC<Props> = ({
  children,
  setModal,
  hideModal,
}) => {
  return (
    <ModalStateContext.Provider
      value={{
        hideModal,
        setModal,
      }}
    >
      {children}
    </ModalStateContext.Provider>
  );
};

export const ModalStateContextProvider = withModal(
  ModalStateContextProviderContainer,
);
